module.exports = __webpack_public_path__ + "media/images/flags/mx-0327b02ecdd6a9df021bd7dd74ffb22b.svg";